module.exports = __webpack_public_path__ + "img/chevron-compact-left.e74f9721.svg";